import { GET_NEWEST_COMMENTS } from '../../constants/ActionTypes';

export function getNewestComments() {
  const path = '/@newest-comments';

  return {
    type: GET_NEWEST_COMMENTS,
    request: {
      op: 'get',
      path: path,
    },
  };
}
